import { Anthem } from '@/model';
import {
  GetTeamAnthemByIdResponse,
  GetTeamAnthemItemResponse,
  GetTeamAnthemResponse,
  PostTeamAnthemResponse,
  PutTeamAnthemResponse,
} from '@/services/response/anthem';
export class AnthemConverter {
  static toDomainFromGetItemResponse(response: GetTeamAnthemItemResponse): Anthem {
    return {
      uuid: response.uuid,
      lyrics: response.lyrics,
      location: response.location,
      checksum: response.checksum,
      team_uuid: response.team_uuid,
      team_name: response.team_name,
      team_image: response.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPaginatedResponse(response: GetTeamAnthemResponse): Anthem[] {
    return response.data.map(AnthemConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromPostResponse(response: PostTeamAnthemResponse): Anthem {
    return {
      uuid: response.uuid,
      lyrics: response.lyrics,
      location: response.location,
      checksum: response.checksum,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromByIdResponse(response: GetTeamAnthemByIdResponse): Anthem {
    return {
      uuid: response.uuid,
      lyrics: response.lyrics,
      location: response.location,
      checksum: response.checksum,
      team_uuid: response.team_uuid,
      team_name: response.team_name,
      team_image: response.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutResponse(response: PutTeamAnthemResponse): Anthem {
    return {
      uuid: response.uuid,
      lyrics: response.lyrics,
      location: response.location,
      checksum: response.checksum,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
